import { render, staticRenderFns } from "./EditCustomerForm.vue?vue&type=template&id=64f90181&"
import script from "./EditCustomerForm.vue?vue&type=script&lang=js&"
export * from "./EditCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports